<template>
  <div class="app-container warn-config-container" v-loading="loading">
    <div class="config-card">
      <h2 class="config-title">预警提醒配置</h2>
      
      <el-form ref="warnForm" :model="form" :rules="rules" label-width="180px" class="warn-form">
        <!-- 预警类型（仅展示） -->
        <el-form-item label="预警类型：">
          <span class="form-text">客户项目中-<关键人>字段缺失</span>
        </el-form-item>

        <el-divider></el-divider>

        <!-- 预警规则 -->
        <div class="rule-section">
          <el-form-item label="预警规则：" prop="amountThreshold">
            <span class="label-text">项目预计成交金额 ></span>
            <el-input-number
              v-model="form.amountThreshold"
              :min="0"
              :precision="0"
              :controls="false"
              placeholder="请输入数字"
              class="input-number"
            ></el-input-number>
            <span class="unit-text">万，同时；</span>
          </el-form-item>

          <el-form-item label="" prop="timeThreshold" label-width="180px">
            <span class="label-text">字段缺失时间</span>
            <el-input-number
              v-model="form.timeThreshold"
              :min="0"
              :precision="0"
              :controls="false"
              placeholder="请输入数字"
              class="input-number"
              style="margin-left: 47px;"
            ></el-input-number>
            <span class="unit-text">天，钉钉消息提醒</span>
          </el-form-item>

          <el-form-item label="" label-width="180px">
            <div class="notice-text">注：开始提醒后，每日上午10点钉钉推动提醒。</div>
          </el-form-item>
        </div>

        <el-divider></el-divider>

        <!-- 预警提醒 -->
        <el-form-item label="预警提醒：">
          <div class="webhook-section">
            <div class="webhook-label">钉钉打群的聊天机器人webhook信息制到这里</div>
            
            <div class="webhook-item">
              <el-input
                v-model="form.webhookUrl1"
                placeholder="请输入webhook地址1"
                class="webhook-input"
              ></el-input>
            </div>
            
            <div class="webhook-item">
              <el-input
                v-model="form.webhookUrl2"
                placeholder="请输入webhook地址2"
                class="webhook-input"
              ></el-input>
            </div>
            
            <div class="webhook-item">
              <el-input
                v-model="form.webhookUrl3"
                placeholder="请输入webhook地址3"
                class="webhook-input"
              ></el-input>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <!-- 底部按钮 -->
      <div class="footer-buttons">
        <el-button type="primary" @click="handleSave" :loading="saving">
          保存 💡
        </el-button>
        <el-button @click="handleCancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getWarningConfig, updateWarningConfig } from "@/api/crm/warning";

export default {
  name: "WarnPageConfig",
  data() {
    return {
      // 表单数据
      form: {
        amountThreshold: null,
        timeThreshold: null,
        webhookUrl1: "",
        webhookUrl2: "",
        webhookUrl3: ""
      },
      // 表单验证规则
      rules: {
        amountThreshold: [
          { required: true, message: "请输入金额阈值", trigger: "blur" }
        ],
        timeThreshold: [
          { required: true, message: "请输入时间阈值", trigger: "blur" }
        ]
      },
      // 保存状态
      saving: false,
      // 加载状态
      loading: false
    };
  },
  created() {
    this.loadConfig();
  },
  methods: {
    /** 加载配置 */
    loadConfig() {
      this.loading = true;
      getWarningConfig().then(response => {
        if (response.code === 200 && response.data) {
          this.form = {
            ...this.form,
            ...response.data
          };
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$message.error("加载配置失败");
      });
    },

    /** 保存配置 */
    handleSave() {
      this.$refs.warnForm.validate(valid => {
        if (valid) {
          this.saving = true;
          const params = {
            amountThreshold: this.form.amountThreshold,
            timeThreshold: this.form.timeThreshold,
            webhookUrl1: this.form.webhookUrl1 || "",
            webhookUrl2: this.form.webhookUrl2 || "",
            webhookUrl3: this.form.webhookUrl3 || ""
          };

          updateWarningConfig(params).then(response => {
            if (response.code === 200) {
              this.$message.success("保存成功");
              this.loadConfig();
            } else {
              this.$message.error(response.msg || "保存失败");
            }
            this.saving = false;
          }).catch(error => {
            this.$message.error("保存失败");
            this.saving = false;
          });
        } else {
          this.$message.error("请完善表单信息");
        }
      });
    },

    /** 取消 */
    handleCancel() {
      this.loadConfig();
    }
  }
};
</script>

<style lang="scss" scoped>
.warn-config-container {
  padding: 20px;
}

.config-card {
  background: #fff;
  padding: 30px;
  border-radius: 4px;
  max-width: 1200px;
}

.config-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.warn-form {
  margin-top: 20px;

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  .form-text {
    font-size: 14px;
    color: #303133;
  }

  .rule-section {
    .label-text {
      font-size: 14px;
      color: #606266;
      margin-right: 8px;
    }

    .input-number {
      width: 200px;
      margin: 0 8px;

      ::v-deep .el-input__inner {
        text-align: left;
      }
    }

    .unit-text {
      font-size: 14px;
      color: #606266;
      margin-left: 8px;
    }

    .notice-text {
      font-size: 14px;
      color: #f56c6c;
      margin-left: 180px;
      margin-top: -10px;
    }
  }

  .webhook-section {
    width: 100%;

    .webhook-label {
      font-size: 14px;
      color: #606266;
      margin-bottom: 12px;
    }

    .webhook-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .webhook-input {
        flex: 1;
        max-width: 600px;
      }

      .delete-btn {
        margin-left: 10px;
        color: #909399;
        font-size: 18px;
        padding: 0;

        &:hover {
          color: #f56c6c;
        }
      }
    }

    .add-btn {
      color: #409eff;
      padding: 0;
      font-size: 14px;

      &:hover {
        color: #66b1ff;
      }
    }
  }
}

.footer-buttons {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
  text-align: center;

  .el-button {
    min-width: 120px;
    padding: 12px 40px;
    
    &.el-button--primary {
      background-color: #1677ff;
      border-color: #1677ff;

      &:hover {
        background-color: #3b8ff8;
        border-color: #3b8ff8;
      }
    }

    &:not(.el-button--primary) {
      background-color: #d9d9d9;
      border-color: #d9d9d9;
      color: #000;

      &:hover {
        background-color: #c0c0c0;
        border-color: #c0c0c0;
      }
    }
  }
}

::v-deep .el-divider--horizontal {
  margin: 24px 0;
}
</style>
